import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { createContext, useContext, ReactNode } from 'react';
import AppInsights from './app-insights';

/**
 * Type of AppInsights
 */
type AppInsightsContextValue = InstanceType<typeof ApplicationInsights>;

/**
 * AppInsights Context definition
 */
export const AppInsightsContext =
    createContext<AppInsightsContextValue>(AppInsights);

type AppInsightsProviderProps = {
    children: ReactNode;
};

/**
 * Application Insight Provider
 *
 * @param children
 * @returns {JSX.Element}
 */
export function AppInsightsProvider({ children }: AppInsightsProviderProps) {
    return (
        <AppInsightsContext.Provider value={AppInsights}>
            {children}
        </AppInsightsContext.Provider>
    );
}

/**
 * Returns the AppInsights instance
 * @returns
 */
export function useAppInsights(): AppInsightsContextValue {
    return useContext(AppInsightsContext);
}
